"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _config = _interopRequireDefault(require("../../../../targets/cord_sanofi/config.js"));

var _UserProfile = _interopRequireDefault(require("./UserProfile.scss"));

var _ThemeStore = _interopRequireDefault(require("../ThemeStore/ThemeStore2"));

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _ContentStore = _interopRequireDefault(require("../../../KESI2/Stores/ContentStore"));

var _DataStoreComponent2 = _interopRequireDefault(require("../DataStoreComponent/DataStoreComponent2"));

var _strings = require("./strings");

var _MuiAlertHelper = require("../../../helpers/MuiAlertHelper");

var _UserProfileForm = _interopRequireDefault(require("./UserProfileForm"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var UserProfile = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(UserProfile, _DataStoreComponent);

  var _super = _createSuper(UserProfile);

  function UserProfile(props) {
    var _thisSuper, _thisSuper2, _this;

    (0, _classCallCheck2["default"])(this, UserProfile);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateUserData", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var oldUserData, userData;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.state.salutation.trim() === '' || _this.state.firstName.trim() === '' || _this.state.lastName.trim() === '' || _this.state.department.trim() === '' || _this.state.location.trim() === '' || _this.state.phoneNumber.trim() === '')) {
                _context.next = 3;
                break;
              }

              _this.openUserDataDialog((0, _strings.getString)('FILL_ALL_FIELDS'));

              return _context.abrupt("return");

            case 3:
              oldUserData = _this.state.data[_DataStore.DATA_STORE_PATHS.USER_PROFILE];
              userData = (0, _assign["default"])({}, oldUserData, {
                firstName: _this.state.firstName.trim(),
                lastName: _this.state.lastName.trim(),
                location: _this.state.location.trim(),
                department: _this.state.department.trim(),
                phoneNumber: _this.state.phoneNumber.trim(),
                salutation: _this.state.salutation.trim()
              });
              console.log('setting userData', userData);
              _context.next = 8;
              return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.USER_PROFILE, userData);

            case 8:
              if (_this.props.editMode && _this.props.onDone) {
                _this.props.onDone();
              }

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "cancelEditing", function () {
      if (_this.props.onCancel) {
        _this.props.onCancel();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleChange", function (id, value) {
      var state = _this.state;
      state[id] = value;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "openUserDataDialog", function () {
      var errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var userData = _this.state.data[_DataStore.DATA_STORE_PATHS.USER_PROFILE];

      if (userData) {
        _this.setState({
          firstName: userData.firstName,
          lastName: userData.lastName,
          location: userData.location,
          department: userData.department,
          phoneNumber: userData.phoneNumber,
          salutation: userData.salutation
        });
      }

      var okButton = {
        label: (0, _strings.getString)('OK'),
        callback: function callback() {
          _this.updateUserData();
        }
      };
      var cancelButton = {
        label: (0, _strings.getString)('CANCEL'),
        callback: function callback() {
          _this.cancelEditing();
        }
      };

      var message = /*#__PURE__*/_react["default"].createElement(_UserProfileForm["default"], {
        firstName: _this.state.firstName,
        lastName: _this.state.lastName,
        salutation: _this.state.salutation,
        location: _this.state.location,
        department: _this.state.department,
        phoneNumber: _this.state.phoneNumber,
        errorMessage: errorMessage,
        onHandleChange: _this.handleChange
      });

      (0, _MuiAlertHelper.showAlertWithOptions)({
        title: (0, _strings.getString)('CHANGE_USERDATA_TITLE'),
        react: message,
        buttons: [cancelButton, okButton],
        severity: _MuiAlertHelper.SEVERITIES.HIGH,
        size: 'large',
        showCloseButton: false
      });
    });
    _this.state = {
      firstName: '',
      lastName: '',
      location: '',
      department: '',
      phoneNumber: '',
      salutation: ''
    };
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(UserProfile.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.USER_PROFILE]);
    (0, _get2["default"])((_thisSuper2 = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(UserProfile.prototype)), "addStoresAndKeys", _thisSuper2).call(_thisSuper2, [{
      store: _ThemeStore["default"],
      keys: ['currentTheme', 'navbar', 'button']
    }, {
      store: _ContentStore["default"],
      keys: ['content']
    }]);
    return _this;
  }

  (0, _createClass2["default"])(UserProfile, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (_config["default"].isUserProfileComplete()) {
        var userData = this.state.data[_DataStore.DATA_STORE_PATHS.USER_PROFILE];
        this.setState({
          firstName: userData.firstName,
          lastName: userData.lastName,
          location: userData.location,
          department: userData.department,
          phoneNumber: userData.phoneNumber,
          salutation: userData.salutation
        });
      }

      if (this.props.editMode) {
        this.openUserDataDialog();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (!_config["default"].isUserProfileComplete()) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          onClick: function onClick() {
            return _this2.openUserDataDialog();
          }
        }, "Es wurden bisher keine Daten eingegeben. Geben Sie Ihre Daten jetzt ein.");
      }

      var userData = this.state.data[_DataStore.DATA_STORE_PATHS.USER_PROFILE];
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _UserProfile["default"].editIcon,
        onClick: function onClick() {
          return _this2.openUserDataDialog();
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        name: 'pencil'
      })), /*#__PURE__*/_react["default"].createElement("table", {
        className: _UserProfile["default"].userProfileContainer
      }, /*#__PURE__*/_react["default"].createElement("tbody", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        className: "".concat(_UserProfile["default"].bold, " ").concat(_UserProfile["default"].paddingBottom)
      }, (0, _strings.getString)('SALUTATION'), ":"), /*#__PURE__*/_react["default"].createElement("td", {
        className: "".concat(_UserProfile["default"].paddingBottom)
      }, userData.salutation ? "".concat(userData.salutation) : (0, _strings.getString)('NO_SALUTATION'))), /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        className: "".concat(_UserProfile["default"].bold, " ").concat(_UserProfile["default"].paddingBottom)
      }, (0, _strings.getString)('EMAIL'), ":"), /*#__PURE__*/_react["default"].createElement("td", {
        className: "".concat(_UserProfile["default"].paddingBottom)
      }, userData.email)), /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        className: "".concat(_UserProfile["default"].bold, " ").concat(_UserProfile["default"].paddingBottom)
      }, (0, _strings.getString)('NAME'), ":"), /*#__PURE__*/_react["default"].createElement("td", {
        className: "".concat(_UserProfile["default"].paddingBottom)
      }, userData.firstName && userData.lastName ? "".concat(userData.firstName, " ").concat(userData.lastName) : (0, _strings.getString)('NO_NAME'))), /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        className: "".concat(_UserProfile["default"].bold, " ").concat(_UserProfile["default"].paddingBottom)
      }, (0, _strings.getString)('DEPARTMENT'), ":"), /*#__PURE__*/_react["default"].createElement("td", {
        className: "".concat(_UserProfile["default"].paddingBottom)
      }, userData.department ? "".concat(userData.department) : (0, _strings.getString)('NO_DEPARTMENT'))), /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        className: "".concat(_UserProfile["default"].bold, " ").concat(_UserProfile["default"].paddingBottom)
      }, (0, _strings.getString)('LOCATION'), ":"), /*#__PURE__*/_react["default"].createElement("td", {
        className: "".concat(_UserProfile["default"].paddingBottom)
      }, userData.location ? "".concat(userData.location) : (0, _strings.getString)('NO_LOCATION'))), /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        className: "".concat(_UserProfile["default"].bold, " ").concat(_UserProfile["default"].paddingBottom)
      }, (0, _strings.getString)('PHONE_NUMBER'), ":"), /*#__PURE__*/_react["default"].createElement("td", {
        className: "".concat(_UserProfile["default"].paddingBottom)
      }, userData.phoneNumber ? "".concat(userData.phoneNumber) : (0, _strings.getString)('NO_PHONE_NUMBER'))))));
    }
  }]);
  return UserProfile;
}(_DataStoreComponent2["default"]);

UserProfile.propTypes = {
  editMode: _propTypes["default"].bool,
  onDone: _propTypes["default"].func,
  onCancel: _propTypes["default"].func
};
UserProfile.defaultProps = {
  editMode: false,
  onDone: null,
  onCancel: null
};
var _default = UserProfile;
exports["default"] = _default;